import type { RefObject } from 'react';
import { Loader2 } from 'lucide-react';

interface InfiniteScrollSentinelProps {
  hasNextPage: boolean | undefined;
  isFetchingNextPage: boolean;
  sentinelRef: RefObject<HTMLDivElement | null>;
}

export function InfiniteScrollSentinel({
  hasNextPage,
  isFetchingNextPage,
  sentinelRef,
}: InfiniteScrollSentinelProps) {
  if (!hasNextPage) return null;

  return (
    <div ref={sentinelRef} className="flex justify-center py-4">
      {isFetchingNextPage && <Loader2 className="h-5 w-5 animate-spin" />}
    </div>
  );
}
